<template>
  <div class="d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="receipts-reports"
      :filtersValue="filtersValue"
      :sort="sort"
      :date="date"
      :externalFilters="external"
    ></filtered-data>
    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <h1 class="mr-auto">Чеки</h1>
        <div class="input-group mr-1" style="max-width: 15em">
        <div class="input-group-prepend">
          <span class="input-group-text">ИНН</span>
        </div>
          <input type="number" class="form-control" v-model="inn" min="0">
        </div>
        <div class="input-group mr-1" style="max-width: 27em">
        <div class="input-group-prepend">
          <span class="input-group-text">Номер фискального накопителя</span>
        </div>
          <input type="number" class="form-control"  v-model="fsNumber" min="0">
        </div>
        <button class="btn btn-sm btn-outline-primary mr-3" @click="save">Применить</button>
        <el-date-picker
          class="mr-2"
          v-model="date"
          type="datetimerange"
          :clearable="false"
          value-format="yyyy-MM-ddTHH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          align="right"
          range-separator="–"
          :picker-options="pickerOptions"
          size="small"
        />
        <btn-filters
          :data="data"
          endpoint="receipts-reports"
          v-model="filtersValue"
        ></btn-filters>
      </div>
    </div>

    <data-table-full-height
      v-if="data && data.data"
      :data="data.data"
      @sort-change="sortChange"
      show-summary
    >
      <table-column-serial-number :fixed="true"/>
      <el-table-column prop="address" label="Адрес установки" :show-overflow-tooltip="true" min-width="300"/>
      <el-table-column align="center" sortable="custom" prop="count" label="Всего чеков" min-width="120">
        <template slot-scope="{row}">
          <router-link :to="{ path: '/receipts', query: { machine_id: row.id }}">
            <number :number="row.count"/>
          </router-link>
        </template>
      </el-table-column>
      <table-column-number align="center" sortable="custom" prop="successful" label="Удачных" min-width="120"/>
      <table-column-number align="center" sortable="custom" prop="unsuccessful" label="Неудачных" min-width="120"/>

      <table-column-date prop="last_receipt" label="Последний чек" align="right"/>
    </data-table-full-height>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    metaInfo: {title: 'Чеки'},
    data () {
      return {
        filtersValue: null,
        data: {},
        sort: null,
        date: [
          moment().subtract(7, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
          moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
        ],
        pickerOptions: {
          firstDayOfWeek: 1,
        },
        inn: null,
        fsNumber: null,
        external: null,
      }
    },
    methods: {
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          this.sort = `${sort.prop}:${order}`
        } else {
          this.sort = null
        }
      },
      save () {
        this.external = this.externalData
      }
    },
    computed: {
      externalData () {
        let data = {}
        if (this.inn) data.inn = this.inn
        if (this.fsNumber) data.fs_number = this.fsNumber
        return data
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/reports/receipts.vue